const { axiosDefault, handleErrors } = require('../utils/defaults');

const homeService = {
  admin: {
    list: async () => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`api/home/admin/`);

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },

    save: async (cards) => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.post(`/api/home/admin/`, cards);

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },
  user: {
    list: async () => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`api/home/`);

        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },
};

export default homeService;
